<!-- Blur backdrop (mobile only) -->
@if (isMenuOpen()) {
  <div
    class="fixed inset-0 z-30 backdrop-blur-xs bg-black/20 md:hidden"
    (click)="closeMenu()"
  ></div>
}

<nav class="w-full fixed top-0 left-0 z-40 animate-fade-in-down bg-white">
  <ul class="2xl:container 2xl:mx-auto flex items-center justify-between md:px-10 px-4 py-2.5">
    <li class="cursor-pointer w-fit">
      <a routerLink="/"><img src="logo1.png" alt="Yarrow Logo" class="h-10" /></a>
    </li>

    <!-- Desktop menu -->
    <li class="hidden md:flex items-center justify-center gap-6">
      <!-- Language toggle -->
      <div class="flex items-center gap-0.5 text-sm font-medium">
        <button
          (click)="switchLanguage('en')"
          [class.text-main-blue-light]="currentLocale === 'en'"
          [class.text-gray-300]="currentLocale !== 'en'"
          class="cursor-pointer transition-all duration-200 hover:text-main-blue-light px-1"
        >
          EN
        </button>
        <span class="text-gray-300">|</span>
        <button
          (click)="switchLanguage('th')"
          [class.text-main-blue-light]="currentLocale === 'th'"
          [class.text-gray-300]="currentLocale !== 'th'"
          class="cursor-pointer transition-all duration-200 hover:text-main-blue-light px-1"
        >
          TH
        </button>
      </div>

      <a
        class="bg-main-blue-light text-white flex items-center justify-center gap-2 text-sm px-5 py-2.5 rounded-full cursor-pointer hover:bg-main-blue hover:text-white transition-all duration-300 active:bg-main-blue active:scale-95"
        href="https://lin.ee/qe4HGmS"
        target="_blank"
      >
        <span i18n="organizer.nav|Get in touch button@@organizer.nav.getInTouch">Get In Touch</span>
        <img src="open_in_new.svg" alt="Open in new tab" class="w-4 h-4 inline-block" />
      </a>
    </li>

    <!-- Hamburger button (mobile only) -->
    <li class="flex md:hidden">
      <button
        class="text-main-blue-light p-1 cursor-pointer focus:outline-none"
        (click)="toggleMenu()"
        aria-label="Toggle menu"
      >
        @if (!isMenuOpen()) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        }
      </button>
    </li>
  </ul>

  <!-- Mobile dropdown -->
  @if (isMenuOpen()) {
    <div class="md:hidden flex flex-col animate-fade-in-down">
      <a
        class="text-white text-center font-medium hover:bg-main-blue transition-all duration-300 cursor-pointer bg-main-blue-light w-full py-2.5 flex items-center justify-center gap-2"
        (click)="closeMenu()"
        href="https://lin.ee/qe4HGmS"
        target="_blank"
      >
        <span i18n="organizer.nav|Get in touch button@@organizer.nav.getInTouch">Get In Touch</span>
        <img src="open_in_new.svg" alt="Open in new tab" class="w-4 h-4 inline-block" />
      </a>
      <!-- Mobile language toggle -->
      <div
        class="bg-white border-t border-gray-100 w-full py-2.5 flex items-center justify-center gap-2 text-sm font-medium"
      >
        <button
          (click)="switchLanguage('en')"
          [class.text-main-blue-light]="currentLocale === 'en'"
          [class.text-gray-300]="currentLocale !== 'en'"
          class="cursor-pointer transition-all duration-200 hover:text-main-blue-light px-2"
        >
          EN
        </button>
        <span class="text-gray-300">|</span>
        <button
          (click)="switchLanguage('th')"
          [class.text-main-blue-light]="currentLocale === 'th'"
          [class.text-gray-300]="currentLocale !== 'th'"
          class="cursor-pointer transition-all duration-200 hover:text-main-blue-light px-2"
        >
          TH
        </button>
      </div>
    </div>
  }
</nav>
